import type { UserProfile } from '@/types/profile';
import { dbPut, dbGetAll, dbDelete } from './db';

export async function saveProfile(profile: UserProfile): Promise<void> {
  await dbPut('profiles', profile);
}

export async function loadProfiles(): Promise<UserProfile[]> {
  return dbGetAll<UserProfile>('profiles');
}

export async function deleteProfile(id: string): Promise<void> {
  await dbDelete('profiles', id);
}
